interface Props {
  size?: number;
}

export default function MoreIcon({ size = 16 }: Props) {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_298_2808)">
        <path
          d="M3.33333 6.66669C2.6 6.66669 2 7.26669 2 8.00002C2 8.73335 2.6 9.33335 3.33333 9.33335C4.06667 9.33335 4.66667 8.73335 4.66667 8.00002C4.66667 7.26669 4.06667 6.66669 3.33333 6.66669Z"
          fill="currentColor"
        />
        <path
          d="M12.6667 6.66669C11.9334 6.66669 11.3334 7.26669 11.3334 8.00002C11.3334 8.73335 11.9334 9.33335 12.6667 9.33335C13.4 9.33335 14 8.73335 14 8.00002C14 7.26669 13.4 6.66669 12.6667 6.66669Z"
          fill="currentColor"
        />
        <path
          d="M7.99996 6.66669C7.26663 6.66669 6.66663 7.26669 6.66663 8.00002C6.66663 8.73335 7.26663 9.33335 7.99996 9.33335C8.73329 9.33335 9.33329 8.73335 9.33329 8.00002C9.33329 7.26669 8.73329 6.66669 7.99996 6.66669Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_298_2808">
          <rect width={size} height={size} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
